import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { useNavigate } from 'react-router-dom';

// @mui
// import Box from '@mui/material/Box';

// css
import '../index.scss';
// import '../../assets/css/form.scss';

// Components
// import AppLayout from '../../layouts/app/AppLayout';
// import UserDrawer from '../../components/drawer/drawer';
import { myPortalState } from '../../state/reducerAtoms/myPortal.atom';
// import Profile from '../profile';
// import MyMessagesList from '../messages/list';
import { getCurrentFacilityURL } from '../../helpers/helper.functions';
import { accessGuard } from '../../helpers/auth.helper';
import AIModuleList from './aiDevelopment/modules-list';




export default function ProviderPortal() {

    const pageName = "Provider portal";
    const navigate = useNavigate()
    const [content, setContent] = React.useState(<></>);
    const { selectedNavItem = 'question', facilityInfo = {} } = useRecoilValue(myPortalState);
    const { design = {} } = facilityInfo;
    React.useEffect(() => {
        // if (!accessGuard('home')) {
        //     navigate(`/${getCurrentFacilityURL()}/profile`)
        // }
        if (selectedNavItem) {
            onSelectNav(selectedNavItem)
        }
        // eslint-disable-next-line
    }, [selectedNavItem]);

    /**
     * Sets the content to display based on the current selection
     * @param {string} item 
     */
    const onSelectNav = (item) => {
        let contentSelected = <span>question</span>
        switch (item) {
            // case 'inbox':
            //     contentSelected = <MyMessagesList />;
            //     break;
            // case 'account':
            //     contentSelected = <Profile />;
            //     break;
            default:
                contentSelected = <AIModuleList />;
                break;
        }
        setContent(contentSelected);
    }

    return (
        <>
            <div className='AppLayout'
                pageName={pageName}
                isLoadHeader={false}
                isLoadFooter={false}
                bodyClassName={`provider-portal ${design.theme || 'default-bg'} ${design.buttonTheme || 'default-clr'} f-wrp`}
            >
                <div sx={{ display: 'flex' }} className="portal-main-structure">
                    {/* <UserDrawer /> */}
                    <div component="main" className='panel-main-body' sx={{ flexGrow: 1, p: 3, display: 'flex', flexDirection: 'column' }}>
                        <div className='panel-main-content'>
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}